import http from '@/request/http'

//获取token
export function getToken(params) {
    const data = params
    return http({
        url: '/api/v1/getToken',
        method: 'post',
        data
    })
}

//登录
export function loginFun(params) {
    const data = params
    return http({
        url: 'api/v1/users/login',
        method: 'post',
        data
    })
}

// 微信扫码登录
export function wxloginFun(params) {
    const data = params
    return http({
        url: 'api/wx-login',
        method: 'post',
        data
    })
}

//获取验证码
export function getVerifyCode(params) {
    const data = params
    return http({
        url: 'api/v1/sendSms',
        method: 'post',
        data
    })
}

//注册
export function registerFun(params) {
    const data = params
    return http({
        url: 'api/v1/users/createUser',
        method: 'post',
        data
    })
}

//找回密码
export function findPassword(params) {
    const data = params
    return http({
        url: 'api/v1/findPassword',
        method: 'post',
        data
    })
}